const normalize = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).trim();
};

const ENTITY_ROUTE_MAP = {
  task: { path: '/tasks', section: 'tasks' },
  need: { path: '/tasks', section: 'needs' },
  event: { path: '/calendar', section: 'events' },
  birthday: { path: '/birthdays', section: 'birthdays' },
  gift: { path: '/gifts', section: 'gifts' },
  document: { path: '/documents', section: 'documents' },
  communication: { path: '/contacts', section: 'contacts' }
};

const parseUrlToTarget = (urlValue) => {
  const rawUrl = normalize(urlValue);
  if (!rawUrl) return null;

  try {
    const parsed = new URL(rawUrl, 'https://app.mentallast.de');
    return {
      path: parsed.pathname,
      query: Object.fromEntries(parsed.searchParams.entries())
    };
  } catch (error) {
    void error;
    return null;
  }
};

export const resolvePushNavigationTarget = (notificationData = {}) => {
  const target = notificationData?.target && typeof notificationData.target === 'object' ? notificationData.target : {};
  const entityType = normalize(notificationData?.entityType || target?.type).toLowerCase();
  const entityId = normalize(notificationData?.entityId || target?.id || target?.highlightId);
  const explicitRoute = normalize(notificationData?.targetRoute || target?.targetRoute || target?.path);
  const targetSection = normalize(notificationData?.targetSection || target?.targetSection);
  const highlightId = normalize(notificationData?.highlightId || target?.highlightId || entityId);

  const parsedUrl = parseUrlToTarget(notificationData?.url);
  if (parsedUrl?.path && parsedUrl.path !== '/dashboard') {
    const query = {
      ...parsedUrl.query,
      ...(highlightId ? { highlight: highlightId } : {}),
      ...(targetSection ? { section: targetSection } : {})
    };
    return {
      path: parsedUrl.path,
      query,
      replace: true
    };
  }

  if (explicitRoute) {
    return {
      path: explicitRoute,
      query: {
        ...(entityType ? { type: entityType } : {}),
        ...(entityId ? { id: entityId } : {}),
        ...(highlightId ? { highlight: highlightId } : {}),
        ...(targetSection ? { section: targetSection } : {})
      },
      replace: true
    };
  }

  const mapped = ENTITY_ROUTE_MAP[entityType] || { path: '/dashboard', section: 'dashboard' };

  if (entityType && entityId) {
    return {
      path: '/open',
      query: {
        type: entityType,
        id: entityId,
        ...(highlightId ? { highlight: highlightId } : {}),
        section: targetSection || mapped.section
      },
      replace: true
    };
  }

  return {
    path: mapped.path,
    query: {
      ...(targetSection || mapped.section ? { section: targetSection || mapped.section } : {}),
      ...(highlightId ? { highlight: highlightId } : {})
    },
    replace: true
  };
};

export const isPushNotificationClickMessage = (payload) =>
  Boolean(payload && payload.type === 'ml:notification-click' && payload.payload);
